<template>
  <div class="container-fluid" id="login">
    <div class="row login-page">
      <div class="col-lg-6 hidden-md-down login-graphic">
        <h1>{{ getTranslations.visitor_login_welcome_text_1 }}
          <strong>{{ getTranslations.visitor_login_welcome_text_2 }}</strong>{{ getTranslations.visitor_login_welcome_text_3 }}
        </h1>
        <div class="login-page--left">
          <img class="left-img" :src="getTranslations.project_get_started_tablet_img" alt="">
        </div>
      </div>
      <div class="col-lg-6">
        <div class="login-page--right">
          <div class="login-form">
            <form action="">
              <div v-if="facebookFunctionality"
                   :class="['form-group form-group--icon fb_login ', !errorInFb ? '' : 'has-warning']">
                <facebook-login :enteredUsername="testUser"
                                :type="fbActionType"
                                @errorsUpdated="methodForEvent($event)">
                </facebook-login>
                <span v-if="errorInFb" class="form-group__feedback">
                  {{ getMessage(errorInFb) }}
                </span>
              </div>
              <div v-if="facebookFunctionality" class="form-group form-group--or">
                <div><span>{{ getTranslations.visitor_sign_up_and_login_or }}</span></div>
              </div>
              <div v-if="multiOperatorInfo.multiOperatorEnabled" class="operators_selection_wrap ">
                <h1>{{ getTranslations.home_modals_select_operator_my_operator_is }}</h1>
                <div class="operators_radio">
                  <label v-for="(op, index) in multiOperatorInfo.multiOperatorKeys"
                         :key="index"
                         class="operators_radio operators_radio_inline">
                    <img class="operators_icon"
                         :src="getOperatorImage(index)"
                         :alt="getOperatorDisplayName(index)">
                    <input type="radio"
                           name="operator"
                           @click="onOperatorSelect(op)"
                           :value="op">
                    <span></span>
                  </label>
                </div>
                <div class="form-group form-group--icon fb_login has-warning operators_error_msg"
                     v-if="noOperatorSelected && user.operator==''">
                  <span class="form-group__feedback">
                    {{ getTranslations.visitor_sign_up_1_single_country_select_operator }}
                  </span>
                </div>
              </div>
              <div class="form-group form-group--icon">
                <input type="text" class="form-group__textfield"
                       :placeholder="getTranslations.visitor_login_placeholder_enter_username"
                       v-model="user.username"
                       @click.prevent="change"/>
                <i class="icon-profile"></i>
              </div>
              <div :class="['form-group', 'form-group--icon', !user.hasErrors ? '' : 'has-warning']">
                <input type="password"
                       :class="['form-group__textfield', !user.hasErrors ? 'has-success' : 'has-warning']"
                       :placeholder="getTranslations.visitor_login_placeholder_enter_password"
                       v-model="user.password"
                       @click.prevent="change"/>
                <span v-show="getMessage(user.message)" class="form-group__feedback">
                  {{ getMessage(user.message) }}
                </span>
                <i class="icon-lock"></i>
              </div>
              <div class="row login-bottom">
                <div class="col">
                  <div class="form-group form-group--checkbox">
                    <input id="remember_me" type="checkbox" v-model="rememberMeParameter"><label
                    for="remember_me">{{ getTranslations.visitor_login_remember_me }}</label>
                  </div>
                </div>
                <div class="col">
                  <div class="login-form__forgot-password">
                    <router-link :to="'forgotPassword1'">{{ getTranslations.visitor_login_forgot_password }}</router-link>
                  </div>
                </div>
              </div>
              <input type="submit"
                     :value="getTranslations.visitor_login_submit_button_value_login"
                     :class="['btn btn--medium btn--main', ( user.hasErrors  ? 'deactivated' : '')]"
                     @click.prevent="checkButton">
            </form>
            <div v-if="hasWebRegister()" class="login-page__create-account">
              <span>{{ getTranslations.visitor_login_new_here }}</span>
              <a style="cursor:pointer" @click.prevent="goToRegistration">{{ getTranslations.visitor_login_create_account }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fade-transition>
      <email-success v-if="showThankYouEmailModal"></email-success>
    </fade-transition>

  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import FacebookLogin from './FacebookLogin';
import FadeTransition from '../home/modals/shared/FadeTransition';
import EmailSuccess from '../home/modals/profile/EmailSuccess';

export default {
  components: { EmailSuccess, FadeTransition, FacebookLogin },
  name: 'login',
  mixins: [RegistrationFlowMixin],
  data() {
    return {
      noOperatorSelected: false,
      testUser: 'User',
      fbActionType: 'login',
      errorInFb: null,
      rememberMeParameter: true,
      user: {
        operator: '',
        username: '',
        password: '',
        message: '',
        hasErrors: false,
        TokenObject: '',
        tokenExists: false,
      },
    };
  },
  created() {
    if (this.verification.checkId && this.verification.email) {
      const payload = {
        email: this.verification.email,
        checkId: this.verification.checkId,
      };
      this.validateEmail({ verification: payload });
    }
  },
  methods: {
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'callForAuthorization',
      'validateEmail',
    ]),
    ...mapActions('common', [
      'updateUserForEmail',
    ]),
    ...mapMutations('common', [
      'updateEmailVerified',
    ]),
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    onOperatorSelect(operator) {
      this.user.operator = operator;
    },
    goToRegistration() {
      this.registrationAction();
    },
    getMessage(key) {
      return this.getTranslations[key] || '';
    },
    methodForEvent(event) {
      this.errorInFb = event;
    },
    checkButton() {
      this.user.message = '';
      this.errorInFb = null;
      const userData = {
        username: this.user.username,
        password: this.user.password,
        rememberMe: this.rememberMeParameter,
        operator: this.user.operator,
      };
      if (this.multiOperatorInfo.multiOperatorEnabled && this.user.operator === '') {
        this.noOperatorSelected = true;
      } else {
        this.callForAuthorization(userData).then(() => {
          if (this.getUserAuthorized) {
            this.getUserLoginDetails().then(() => {
              if (this.getUserAuthorized) {
                this.user.hasErrors = false;
                this.updateUserLanguage();
                this.$router.push('home');
              } else {
                this.user.message = 'visitor_login_server_error';
                this.user.hasErrors = true;
              }
            });
          } else if (sessionStorage.getItem('operatorError') === 'true') {
            this.user.message = 'visitor_login_invalid_operator';
            this.user.hasErrors = true;
            this.errorInFb = null;
          } else {
            this.user.message = 'visitor_login_invalid_password';
            this.user.hasErrors = true;
            this.errorInFb = null;
          }
        });
      }
    },
    change() {
      this.errorInFb = null;
      this.user.hasErrors = false;
      this.user.message = '';
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'verification',
      'twoStepRegistration',
      'facebookFunctionality',
      'multiOperatorInfo',
    ]),
    ...mapState('profile', [
      'showThankYouEmailModal',
    ]),
    ...mapGetters('i18n', [
      'getTranslationByOperator',
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Login.vue